import VueRecaptcha from 'vue-recaptcha';
export default {
    name: "recaptcha",
    data() {
        return {
            site_key: '6LeP5iQfAAAAANK6cQn1nKvTi5hFMapICMNyIKnP'
        }
    },
    components: {VueRecaptcha},
    methods: {
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
        },
        validate() {
            this.$refs.recaptcha.execute();
        },
    },
}